import React, {memo, useEffect} from "react";
import {Button, Form, Modal, Spinner} from 'react-bootstrap';
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {
    ChangeLoaderFinalBtnLoginAndRegister,
    ChangeLoaderGetPassLoginAndRegister,
    handelChangeDisabledBtnModalLoginAndRegister,
    handelChangeInputModalLoginAndRegister, handelChangeInputsBaseModalLoginAndRegister,
    handelChangeTabSelectModalLoginAndRegister, handelChangeTimerTimeModalLoginAndRegister,
    handelCloseModalLoginAndRegister, handelRestartFormLoginAndRegister
} from "../../../../../redux/actions/modals/modalLoginAndRegister";
import {
    actionModalChangeAddressChangeLoader,
    actionModalChangeAddressChangeShow
} from "../../../../../redux/actions/modals/modalChangeAddress";
import {actionGetAddressUser} from "../../../../../redux/actions/user/user";
import swal from 'sweetalert';
import Swal from 'sweetalert2';

import axios from "axios";
import {
    BASE_URL,
    LOGIN_OR_REGISTER_POST,
    RESEND_ACTIVATION_COD_POST,
    USERS_ACTIVATION_POST,
    USERS_ADDRESS_GET,
    PUBLIC_URL_SERVER
} from "../../../../../apis";
import * as qs from "querystring";
import {actionGetDataProfileUser, actionSetTokenUser} from "../../../../../redux/actions/user/user";
import {handelOpenModalFinalizeRegistration} from "../../../../../redux/actions/modals/modalFinalizeRegistration";
import ReactCodeInput from "react-code-input";

import {toast} from "react-toastify";

import $ from 'jquery';

const ModalLoginAndRegister = () => {
    const dispatch = useDispatch();
    const {
        statusShow,
        tabSelect,
        phoneNumber,
        disabledBtn,
        timer_time,
        code,
        loaderGetPssLogin,
        loaderFinalLogin,
        introduced_code
    } = useSelector(state => state.modalLoginAndRegister);
    const {token} = useSelector(state => state.user);
    const {
        statusShow: modalShoppingCardStatusShow
    } = useSelector(state => state.modalShoppingCard);


    const handleClose = () => {
        dispatch(handelCloseModalLoginAndRegister());
    };

    const handelChangePhoneNumber = () => {
        swal({
            title: "تغییر شماره موبایل",
            text: "آیا میخواهید شماره موبایل خود را تغییر دهید؟",
            buttons: {
                cancel: "انصراف",
                confirm: {
                    text: 'تغییر شماره موبایل',
                    value: "ok",
                },
            },
            icon: "info",
        }).then((value) => {
            if (value === 'ok') {
                dispatch(handelChangeTabSelectModalLoginAndRegister('login'));
                dispatch(handelChangeInputsBaseModalLoginAndRegister('', ''));
                if (!disabledBtn)
                    dispatch(handelChangeDisabledBtnModalLoginAndRegister(true));
            }
        });
    };

    const handelChangeInputPhoneModalLogin = (event) => {
        const {name, value} = typeof event === 'string' ? {name: "phoneNumber", value: event} : event.target;
        dispatch(handelChangeInputModalLoginAndRegister(name, changeNumberPersianAndArabic(value)));
    };

    const handelChangeInputCodeModalLogin = (event) => {
        const {name, value} = typeof event === 'string' ? {name: "code", value: event} : event.target;
        dispatch(handelChangeInputModalLoginAndRegister(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }


    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'base-btn-green-border btn btn-success',
        },
        buttonsStyling: false
    });

    const apiLoginOrRegister = () => {
        axios({
            method: 'post',
            url: BASE_URL + LOGIN_OR_REGISTER_POST,
            data: qs.stringify({
                mobile: phoneNumber,
                introduced_code:introduced_code,
            }), headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    swal({
                        title: "خطا در ورود",
                        text: response.data.message,
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
                    break;
                case 'ok':
                    dispatch(handelChangeTabSelectModalLoginAndRegister('register'));
                    dispatch(handelChangeTimerTimeModalLoginAndRegister(response.data.timer_time));

                    btnOkSingle.fire({
                        title: "ارسال کد تایید",
                        text: `کد تایید با موفقیت به شماره موبایل ${phoneNumber} ارسال شد`,
                        imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                        imageHeight: 45,
                        imageAlt: 'فروت مروت',
                        confirmButtonText: "تایید",
                    }).then((result) => {
                        $(".react-code-input").children('input')[0].focus();
                    });
                    
                    
                    break;
                default:
                    swal({
                        title: "خطا در ورود",
                        text: "لطفا مجددا تلاش کنید.",
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
            }
            dispatch(ChangeLoaderGetPassLoginAndRegister(false));
        }, () => {
            swal({
                title: "خطا در ورود",
                text: "لطفا مجددا تلاش کنید.",
                buttons: {
                    cancel: "تایید",
                },
                icon: "error",
            });
            dispatch(ChangeLoaderGetPassLoginAndRegister(false));
        });
    };

    const validationPhoneNumber = (event) => {
        const {value: phone} = event.target;
        if (phone.length > 11) {
            swal({
                title: "خطا در ورود",
                text: "شماره موبایل نباید بیشتر از 11 رقم باشد.",
                buttons: {
                    cancel: "تایید",
                },
                icon: "warning",
            });
            if (!disabledBtn)
                dispatch(handelChangeDisabledBtnModalLoginAndRegister(true));
        } else if (phone.length === 11) {
            if (disabledBtn)
                dispatch(handelChangeDisabledBtnModalLoginAndRegister(false));
        } else if (phone.length !== 11) {
            if (!disabledBtn)
                dispatch(handelChangeDisabledBtnModalLoginAndRegister(true));
        }
        handelChangeInputPhoneModalLogin(phone);
    };

    const handelBtnModalFormLoginAndRegister = (event) => {
        event.preventDefault();
        switch (tabSelect) {
            case 'login':
                // dispatch({type: LOGIN_USER, payload: {mobile: phoneNumber}});
                dispatch(ChangeLoaderGetPassLoginAndRegister(true));
                apiLoginOrRegister();
                break;
            case 'register':
                dispatch(ChangeLoaderFinalBtnLoginAndRegister(true));
                apiActivation();
                break;
            default:

        }
    };

    const apiActivation = () => {
        var postData = {code: code};
        if(localStorage.getItem('najva_user_token') !== null) {
            postData.device_token = localStorage.getItem('najva_user_token');
            postData.os = 'react';
        }

        axios({
            method: 'post',
            url: BASE_URL + USERS_ACTIVATION_POST,
            data: qs.stringify(postData), 
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    swal({
                        title: "خطا در ورود",
                        text: response.data.message,
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
                    handelChangeInputCodeModalLogin('');
                    break;
                case 'ok':
                    dispatch(actionSetTokenUser(response.data.token));
                    // dispatch(actionGetDataProfileUser(response.data.info));
                    dispatch(actionGetDataProfileUser({
                        ...response.data.info, ...{
                            average_rank: response.data.rank.average_rank,
                            count_rank: response.data.rank.count_rank,
                            rank: response.data.rank.rank,
                            return_period: response.data.rank.return_period,
                            total_score: response.data.rank.total_score
                        }
                    }));

                    restartFormLogin();
                    handleClose();

                    const {fullname, glat, glng} = response.data.info;

                    if (!fullname || !glat || !glng) {
                        dispatch(handelOpenModalFinalizeRegistration());
                    } else {
                        /* 
                        age karbar login nakarde boode va varede sabde kharid shode bashe va rooye dokmeye tayide joziyat zade bashe va be safhe login hedayat shode bashe,
                        bayad aval address hasho behesh namayesh bedim ke entekhab kone
                        */
                        if(modalShoppingCardStatusShow) { 
                            apiHandelGetAddress(response.data.token);
                            dispatch(actionModalChangeAddressChangeShow(true,'home'));
                        }
                    }
                    break;
                default:
                    swal({
                        title: "خطا در ورود",
                        text: "لطفا مجددا تلاش کنید.",
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
                    handelChangeInputCodeModalLogin('');
            }
            dispatch(ChangeLoaderFinalBtnLoginAndRegister(false));
        }, () => {
            swal({
                title: "خطا در ورود",
                text: "لطفا مجددا تلاش کنید.",
                buttons: {
                    cancel: "تایید",
                },
                icon: "error",
            });
            dispatch(ChangeLoaderFinalBtnLoginAndRegister(false));
        });
    };

    const apiHandelGetAddress = (new_token) => {
        dispatch(actionModalChangeAddressChangeLoader(true));
        axios({
            method: 'get',
            url: BASE_URL + USERS_ADDRESS_GET,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': new_token
            },
        }).then((response) => {
            dispatch(actionModalChangeAddressChangeLoader(false));
            dispatch(actionGetAddressUser(response.data.address));
        });
    };

    /*const apiHandelGetAddress = () => {
        dispatch(actionModalChangeAddressChangeLoader(true));
        axios({
            method: 'get',
            url: BASE_URL + USERS_ADDRESS_GET,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': localStorage.getItem('token')
            },
        }).then((response) => {
            if (response.data.status === 'ok') {
                dispatch(actionModalChangeAddressChangeLoader(false));
                dispatch(actionGetAddressUser(response.data.address));
            }
        });
    };*/

    useEffect(() => {
        let setTimeOut;
        if (timer_time > 0 && statusShow)
            setTimeOut = setTimeout(() => {
                if (timer_time > 0) {
                    dispatch(handelChangeTimerTimeModalLoginAndRegister(timer_time - 1));
                } else
                    clearTimeout(setTimeOut);
            }, 1000);
        else {
            if (timer_time !== 0)
                dispatch(handelChangeTimerTimeModalLoginAndRegister(0));
        }
        // eslint-disable-next-line
    }, [timer_time, statusShow]);

    useEffect(() => {
        if (!token && tabSelect === 'register' && code.length === 4 && !loaderFinalLogin) {
            toast.warning('در حال بررسی کد فعال سازی', {
                position: toast.POSITION.BOTTOM_CENTER
            });
            dispatch(ChangeLoaderFinalBtnLoginAndRegister(true));
            apiActivation();
        }
    });

    const handelBtnResendCodeActivation = () => {
        axios({
            method: 'post',
            url: BASE_URL + RESEND_ACTIVATION_COD_POST,
            data: qs.stringify({
                mobile: phoneNumber
            }), headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    swal({
                        title: "خطا در ارسال کد",
                        text: response.data.message,
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
                    break;
                case 'ok':
                    btnOkSingle.fire({
                        title: "ارسال مجدد کد تایید",
                        text: `کد تایید با موفقیت به شماره موبایل ${phoneNumber} ارسال شد`,
                        imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                        imageHeight: 45,
                        imageAlt: 'فروت مروت',
                        confirmButtonText: "تایید",
                    }).then((result) => {
                        $(".react-code-input").children('input')[0].focus();
                    });

                    if (tabSelect !== 'register')
                        dispatch(handelChangeTabSelectModalLoginAndRegister('register'));
                    dispatch(handelChangeTimerTimeModalLoginAndRegister(response.data.timer_time));
                    break;
                default:
                    swal({
                        title: "خطا در ورود",
                        text: "لطفا مجددا تلاش کنید.",
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
            }
        }, () => {
            swal({
                title: "خطا در ورود",
                text: "لطفا مجددا تلاش کنید.",
                buttons: {
                    cancel: "تایید",
                },
                icon: "error",
            });
        });
    };

    const restartFormLogin = () => {
        dispatch(handelRestartFormLoginAndRegister());
    };

    const propsCode = {
        inputStyle: {
            fontFamily: 'IYekan',
            margin: '4px',
            width: '45px',
            borderRadius: '3px',
            fontSize: '18px',
            height: '45px',
            backgroundColor: '#f7f7f7',
            textAlign: 'center',
            color: '#42b029',
            border: '1px solid #9e9e9e',
            borderColor: '#9e9e9e',
        }
    }

    return (
        <BaseModal title={''} show={statusShow}
                   dialogClassName={'modal-login-and-register-custom modal-login-and-register-c-border-head'}
                   handleClose={handleClose}>
            <Modal.Body>
                <div>
                    <img src={'https://fruitmruit.com/icons/fm_logo_ofoghi_new.png'} alt={'logo-fruit-mruit'}
                         className={'w-100'}/>
                </div>
                <div>
                    <h5 className={'text-center mt-1'}>به فروت مروت خوش آمدید</h5>
                    <h6 className={'text-center mt-1'}>ورود / ثبت نام</h6>
                </div>
                <div className={'base-box-forms-login-and-register'}>
                    {tabSelect !== 'register' ?
                        <Form onSubmit={handelBtnModalFormLoginAndRegister}>
                            <Form.Group controlId="formPhoneNumberLogin2" className={'text-center'}>
                                <Form.Label>شماره موبایل خود را وارد کنید</Form.Label>
                                <Form.Control type="text" placeholder="شماره موبایل"
                                              className={'text-center'} autoComplete={"off"}
                                              onChange={validationPhoneNumber}
                                              value={phoneNumber}
                                              name={'phoneNumber'}
                                              autoFocus={true}
                                              pattern="\d*"
                                />
                            </Form.Group>
                            <Form.Group controlId="formPhoneNumberLogin" className={'text-center'}>
                                <Form.Label>کد معرف (جهت ثبت نام)</Form.Label>
                                <Form.Control type="text" placeholder="کد معرف (اختیاری)"
                                              className='text-center' autoComplete={"off"}
                                              onChange={handelChangeInputPhoneModalLogin}
                                              value={introduced_code}
                                              name='introduced_code'
                                />
                            </Form.Group>
                            <Button variant="success"
                                    className={'base-btn-green'}
                                    disabled={disabledBtn || loaderGetPssLogin || loaderFinalLogin} block
                                    onClick={handelBtnModalFormLoginAndRegister}>
                                <div>
                                    <span>دریافت کد  ورود</span>
                                    {loaderGetPssLogin ?
                                        <div className={'d-inline-block'}>
                                            <Spinner className={'mb-1 ml-2'}
                                                     animation="border" size="sm"
                                                     variant="danger"/>
                                        </div>
                                        : ''}
                                </div>
                            </Button>
                        </Form>
                        :
                        <Form>
                            <Form.Group controlId="formLoginFormPassword" className="text-center">
                                <Form.Label>
                                    <div>کد تایید به شماره</div>
                                    <div>{phoneNumber} ارسال شد</div>
                                </Form.Label>
                                <div className={'text-center'} dir={'ltr'}>
                                    <ReactCodeInput type='text' fields={4} name={'code'} id="input-code" value={code} autocomplete={'one-time-code'}
                                                    pattern="\d*"
                                                    disabled={tabSelect === 'login'}

                                                    onChange={handelChangeInputCodeModalLogin} {...propsCode}/>
                                </div>
                                <Form.Text className="text-muted text-center">
                                    کد فعال سازی را وارد کنید
                                </Form.Text>
                                <h6 className={'mt-1 txt-btn-change-number'} onClick={handelChangePhoneNumber}>شماره
                                    موبایل خود را اشتباه وارد کرده اید؟</h6>
                            </Form.Group>
                            <div className={'text-center'}>
                                <Button variant="success"
                                        className={'base-btn-green'}
                                        block
                                        onClick={handelBtnResendCodeActivation}
                                        disabled={timer_time > 0}>
                                    <span>ارسال مجدد </span>
                                    <span>({timer_time})</span>
                                </Button>
                            </div>
                        </Form>
                    }
                </div>
            </Modal.Body>
        </BaseModal>
    )
};

export default memo(ModalLoginAndRegister);
